/**
 * Roambee adapter — IOT-ADAPTER-LIBRARY-1.
 *
 * Tier: third-party-tier-2 (cold-chain + asset tracking)
 * Category: cold_chain, asset_tracker
 *
 * TYPE-ONLY: capability matrix declared; live API calls throw
 * VendorNotIntegratedError. Full integration scheduled once Roambee
 * Honeycomb API credentials are provisioned.
 *
 * Supported devices: Roambee Bee (multi-modal logger — temp, humidity, light,
 * shock, GPS), BeeAware (cellular), BeeAware Beacon (BLE). Capability surface
 * below is the union.
 *
 * Patent anchor: F-IOT-ADAPTER-001.
 */

import { NotImplementedAdapter } from '../NotImplementedAdapter.js';

const ROAMBEE_CAPABILITIES = {
  configKeys: {
    reporting_interval_sec: {
      pushable: true,
      readable: true,
      range: [60, 86400],
      requiresActivation: false,
      unit: 'seconds',
      description: 'Telemetry reporting interval',
    },
    temp_alert_max_c: {
      pushable: true,
      readable: true,
      range: [-40, 85],
      requiresActivation: false,
      unit: '°C',
      description: 'Upper temperature alert threshold',
    },
    temp_alert_min_c: {
      pushable: true,
      readable: true,
      range: [-40, 85],
      requiresActivation: false,
      unit: '°C',
      description: 'Lower temperature alert threshold',
    },
    humidity_alert_max_pct: {
      pushable: true,
      readable: true,
      range: [0, 100],
      requiresActivation: false,
      unit: '%',
      description: 'Upper humidity alert threshold',
    },
  },
  telemetryTypes: [
    'temperature_c', 'humidity_pct', 'shock_g', 'light_lux',
    'gps_position', 'battery_soc_pct', 'cell_signal_dbm',
  ],
  alertingMode: 'cloud',
  otaSupported: false,
  attestationSupported: false,
  rollbackSupported: false,
  pushLatencyExpectedMs: 60_000,
};

export class RoambeeAdapter extends NotImplementedAdapter {
  constructor(device) {
    super(device, 'roambee', ROAMBEE_CAPABILITIES);
  }
}

export function createRoambeeAdapterFactory() {
  return (device) => new RoambeeAdapter(device);
}
